import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import { LOCAL_STORAGE_KEY, ROUTER_CONFIG } from '@careconne/core/configs';
import { AuthService } from '@careconne/core/services/apis';
import { LocalStorageService } from '@careconne/core/services/common';

export const tokenGuard: CanActivateFn = async (route: ActivatedRouteSnapshot): Promise<boolean> => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const localStorageService = inject(LocalStorageService);

  const queryAccessToken = route.queryParams.accessToken || null;
  const queryRefreshToken = route.queryParams.refreshToken || null;
  try {
    if (queryAccessToken && queryRefreshToken) {
      authService.setHasQueryToken(true);
      const userSessionObj = {
        accessToken: queryAccessToken,
        refreshToken: queryRefreshToken,
      };
      await authService.loginByToken(userSessionObj);
      return false;
    }
    return true;
  } catch (e) {
    console.error(e);
    if (queryAccessToken && queryRefreshToken) {
      // Clear userSession when loginByToken fail
      localStorageService.removeItem(LOCAL_STORAGE_KEY.userSession);
    }
    router.navigate([ROUTER_CONFIG.notFound]);
    return false;
  }
};
